import type { LowBmiAssessment } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1116 — F-02's low-BMI section for the doctor, derived on the server.
export async function fetchLowBmiAssessment(
  patientId: string,
): Promise<LowBmiAssessment> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${patientId}/low-bmi-assessment`,
    { headers: commonHeaders(), ...withCredentials },
  );
  return jsonOr401(res);
}
